import { render, staticRenderFns } from "./TourGuide.vue?vue&type=template&id=2b282ac4"
import script from "./TourGuide.vue?vue&type=script&lang=js"
export * from "./TourGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b282ac4')) {
      api.createRecord('2b282ac4', component.options)
    } else {
      api.reload('2b282ac4', component.options)
    }
    module.hot.accept("./TourGuide.vue?vue&type=template&id=2b282ac4", function () {
      api.rerender('2b282ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourGuide.vue"
export default component.exports